export const GQL_LIMITS = {
  doctorClaims: 10,
  ccgClaims: 50,
  ccgExportCsvClaims: 10000,
};
